import React from 'react';
import { dispatch } from '@rematch/core';
import { Portal, List, Image, Card, Button, Icon } from 'semantic-ui-react'
import { Container, Draggable } from 'react-smooth-dnd'
import TreeView from '@zippytech/react-toolkit/TreeView'
import '@zippytech/react-toolkit/TreeView/index.css';
import playbookImage from '../../../../images/svg/noti-designer.svg'
import ActivityDetails from '../drive/modals/ActivityDetailsModal'
import numberFormatter from '../../../../helpers/numberFormatter';
import LabelWithCount from '../../../common/LabelWithCount';

let activityComponents = [];
let getDataActivity = [];
class ActivityTreeMenu extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            open: false,
        }
    }

    handleOpen = async (e, data) => {
        this.setState({ open: true, top: e.clientY - 60, left: e.clientX + 20 })
        await dispatch.lifeCycle.setSingleActivityDetail(data.item)
    }

    openDialog = (isOpen) => {
        this.handleClose()
        this.setState({ isOpen: isOpen })
    }

    handleClose = () => {
        this.setState({ open: false })
    }

    componentWillReceiveProps(newProps) {
        if (this.props.singleActivityDetail !== newProps.singleActivityDetail) {
            this.setState({ activity: newProps.singleActivityDetail })
        }

        if (this.props.publishActivityCountByCategory !== newProps.publishActivityCountByCategory) {
            this.setState({ totalActivity: newProps.publishActivityCountByCategory })
        }
    }

    getActivityList() {
        getDataActivity = [];
        this.props.activityList && this.props.activityList.map((item, i) => {
            item.id = item._id;
            item.type = 'activity';
            item.draggableType = 'activity'
            if (item.isLeafNode)
                getDataActivity.push(item);
        })
        this.createActivityTree();
    }
    getElementToDrag = (i, index) => {
        return getDataActivity[i]
    }
    createActivityTree = () => {
        let activityArray = [];
        if (getDataActivity && getDataActivity.length !== 0) {
            getDataActivity.map((p, i) => {
                activityArray.push({
                    label: <Container
                        key={i}
                        onDragStart={this.onDragStartActivity}
                        onDragEnd={this.onActivityDrop}
                        groupName="Activity"
                        behaviour="copy"
                        getChildPayload={index => this.getElementToDrag(i, index)} >
                        <Portal
                            closeOnPortalMouseLeave
                            closeOnTriggerMouseLeave
                            openOnTriggerMouseEnter
                            mouseEnterDelay={1500}
                            mouseLeaveDelay={100}
                            trigger={
                                // this.props.enableLinkActivity ?
                                // <div className="draggable-item browser-search-draggable"
                                //     style={{
                                //         textOverflow: "ellipsis",
                                //         overflow: "hidden"
                                //     }}>
                                //     {p.name}
                                // </div>
                                // :
                                <Draggable >
                                    <div className="draggable-item browser-search-draggable"
                                        style={{
                                            textOverflow: "ellipsis",
                                            overflow: "hidden"
                                        }}>
                                        {p.name}
                                    </div>
                                </Draggable>
                            }
                            item={p}
                            onOpen={this.handleOpen}
                            onClose={this.handleClose}
                        >
                            <Card
                                style={{
                                    left: this.state.left,
                                    position: 'fixed',
                                    top: this.state.top,
                                    zIndex: 100,
                                    width: "360px",
                                    background: 'white',
                                }}
                            >
                                <Card.Content style={{ padding: "7px 10px" }} >

                                    <List >
                                        <List.Item>
                                            <List.Content floated='right'>
                                                <span className="f_10">Publishing Level</span><br />
                                                <b className="clr-green">{this.props.singleActivityDetail &&
                                                    this.props.singleActivityDetail.packId &&
                                                    this.props.singleActivityDetail.packId.scope === "Public" ? "Public Library" : "Workspace Library"}</b>
                                            </List.Content>
                                            <Image
                                                avatar
                                                src={this.props.singleActivityDetail &&
                                                    this.props.singleActivityDetail.packId &&
                                                    this.props.singleActivityDetail.packId.createdBy &&
                                                    this.props.singleActivityDetail.packId.createdBy.profilePic
                                                }
                                            />
                                            <List.Content>
                                                <span className="f_10">Playbook Owner</span>
                                                <List.Header>
                                                    {this.props.singleActivityDetail &&
                                                        this.props.singleActivityDetail.packId &&
                                                        this.props.singleActivityDetail.packId.createdBy &&
                                                        this.props.singleActivityDetail.packId.createdBy.firstName}&nbsp;
                                                    {this.props.singleActivityDetail &&
                                                        this.props.singleActivityDetail.packId &&
                                                        this.props.singleActivityDetail.packId.createdBy &&
                                                        this.props.singleActivityDetail.packId.createdBy.lastName}
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Card.Content>
                                <Card.Content style={{ padding: "7px 10px" }} >
                                    <List >
                                        <List.Item>
                                            <Icon style={{
                                                height: "14px",
                                                float: "left",
                                                width: '20px',
                                                margin: "3px 2px 0px 5px",
                                                color: "#97b0bd",
                                                fontSize: "14px",
                                                textAlign: 'left',
                                                padding: "0"
                                            }} name="tasks" />
                                            <List.Content style={{
                                                margin: "0 0 0 5px", float: 'left',
                                                width: 'calc(100% - 35px)'
                                            }}>
                                                <span className="f_10">Activity Name</span>
                                                <List.Header>{this.props.singleActivityDetail.name}</List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Card.Content>
                                <Card.Content style={{ padding: "7px 10px" }} >
                                    <List >
                                        <List.Item>
                                            <Image style={{
                                                height: "14px", float: "left",
                                                width: '20px',
                                                margin: "0 7px 0 0"
                                            }} src={playbookImage} />
                                            <List.Content style={{
                                                margin: "0 0 0 5px", float: 'left',
                                                width: 'calc(100% - 35px)'
                                            }}>
                                                <span className="f_10">Playbook Name</span>
                                                <List.Header>{
                                                    this.props.singleActivityDetail &&
                                                    this.props.singleActivityDetail.packId &&
                                                    this.props.singleActivityDetail.packId.name}</List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Card.Content>
                                <Card.Content style={{ padding: "7px 10px" }} >
                                    <List style={{
                                        width: "70%",
                                        float: "left"
                                    }}>
                                        <List.Item>
                                            <Icon style={{
                                                height: "14px",
                                                float: "left",
                                                width: '20px',
                                                margin: "3px 2px 0px 5px",
                                                color: "#97b0bd",
                                                fontSize: "14px",
                                                textAlign: 'left',
                                                padding: "0"
                                            }} name="clock outline" />
                                            <List.Content style={{
                                                margin: "0 0 0 5px", float: 'left',
                                                width: 'calc(100% - 35px)'
                                            }}>
                                                <span className="f_10">Activity Duration</span>
                                                <List.Header>
                                                    {this.props.singleActivityDetail.duration}
                                                    {this.props.singleActivityDetail.duration === 0 || this.props.singleActivityDetail.duration === 1 ? " Day" : " Days"}
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                    <Button
                                        size='tiny'
                                        className="float-right button-submit"
                                        content="Details"
                                        style={{ padding: "5px 10px" }}
                                        onClick={() => this.openDialog(true)} />
                                </Card.Content>
                            </Card>
                        </Portal>


                    </Container>
                });
            });
            if (this.state.totalActivity && this.state.totalActivity[0] && this.state.totalActivity[0].count > 10 && this.state.totalActivity[0].count !== getDataActivity.length) {
                activityArray.push({
                    label: <Button
                        className="button-info"
                        size='tiny'
                        style={{ width: "calc(100% - 5px)" }}
                        onClick={() => this.props.setDataAsPerCategory(null, null, getDataActivity.length + 10, "activity")}>Load More</Button>
                });
            }

        } else {
            activityArray.push({
                label: <span className="clr-gray">No Activity To Display</span>
            })
        }

        let act = {
            label: <LabelWithCount labelClass="bg-blue" label="Activities" count={this.state.totalActivity && this.state.totalActivity[0] && this.state.totalActivity[0].count ? this.state.totalActivity[0].count : 0} />,
            nodes: activityArray
        }


        activityComponents = []
        if (this.props.collapsedResourcePaneIndexTemp !== 0) {
            activityComponents.push(act);
        }
    }

    onDragStartActivity = ({ payload }) => {
        if (payload !== null && payload !== undefined && payload !== 'undefined') {
            dispatch.lifeCycle.setIsDragableFlag('activity')
        }
    }
    onActivityDrop = ({ payload }) => {
        dispatch.lifeCycle.setIsDragableFlag(null);
    }

    render() {
        this.getActivityList();
        return (
            (this.props.arrangementPaneActiveButtonFlag === "Assign" || this.props.selectedPracticeLibrary.status === 4) ? null :
                <div >
                    <TreeView
                        className="activityList heightAuto browserPane noHoverEffect"
                        defaultCollapsedDepth={0}
                        dataSource={activityComponents}
                        enableHoverStyle={false}
                        enableKeyboardNavigation={false}
                    />
                    <ActivityDetails
                        isOpen={this.state.isOpen}
                        activity={this.state.activity}
                        openDialog={this.openDialog}
                    />
                </div>
        );
    }
}
export default ActivityTreeMenu;